<div class="container-fluid m-0 p-0">
    <div class="row">
        <div class="col-12">
            <div class="bg-white border pt-3 my-4">
                <h5 class="font-16 font-black px-3" style="display:inline;clear:none;">{{ "WARNING_LETTERS" |
                    translate
                    | titlecase }}</h5>
                <app-loader [show]="showLoader"></app-loader>
                <br>
                <div id="accordion" *ngIf="showLoader==false">
                    <div class="card">
                        <div id="collapseOne">
                            <div class=" card-body">
                                <form [formGroup]="searchForm" (change)="searchFormChange()"
                                    (submit)="searchFormSubmit()">
                                    <div class="row">
                                        <div class="col-md-3 form-group px-md-5 mb-1">
                                            <label class="font-bold">{{ "ACADMIC_YEAR" | translate | titlecase
                                                }}</label>
                                            <select class="form-control custom-select" formControlName="year"
                                                (change)="getYearSemesters()">
                                                <option value="" [selected]="true">{{ "SELECT" | translate | titlecase
                                                    }}
                                                </option>
                                                <option *ngFor="let field of years" [value]="field.id">
                                                    {{
                                                    (globals.lang == 'ar')? field?.yearDescAr : field?.yearDescEn
                                                    }}
                                                </option>
                                            </select>
                                            <div class="alert alert-danger py-1 mt-1"
                                                *ngIf="searchForm.controls.year.touched && searchForm.controls.year.invalid && searchForm.dirty">
                                                {{ "THIS_FIELD_IS_REQUIRED" | translate | titlecase }}
                                            </div>
                                        </div>
                                        <div class="col-md-3 form-group px-md-5 mb-1">
                                            <label class="font-bold">{{ "SEMESTER" | translate | titlecase }}</label>
                                            <select class="form-control custom-select" formControlName="semester"
                                                (change)="getBatches();">
                                                <option value="" [selected]="true">{{ "SELECT" | translate | titlecase
                                                    }}
                                                </option>
                                                <option *ngFor="let field of semesters" [value]="field.id">
                                                    {{
                                                    (globals.lang == 'ar')? field?.semesterNameAr :
                                                    field?.semesterNameEn
                                                    }}
                                                </option>
                                            </select>
                                            <div class="alert alert-danger py-1 mt-1"
                                                *ngIf="searchForm.controls.semester.touched && searchForm.controls.semester.invalid && searchForm.dirty">
                                                {{ "THIS_FIELD_IS_REQUIRED" | translate | titlecase }}
                                            </div>
                                        </div>
                                        <div class="col-md-3 form-group px-md-5 mb-1">
                                            <label class="font-bold">{{ "BATCH" | translate | titlecase }}</label>
                                            <select class="form-control custom-select" formControlName="batch"
                                                (change)="getStudentsByBatch()">
                                                <option value="" [selected]="true">{{ "SELECT" | translate | titlecase
                                                    }}
                                                </option>
                                                <option *ngFor="let field of batches" [value]="field.id">
                                                    {{
                                                    (globals.lang == 'ar')? field?.gradeNameAr : field?.gradeNameEn
                                                    }}
                                                </option>
                                            </select>
                                            <div class="alert alert-danger py-1 mt-1"
                                                *ngIf="searchForm.controls.batch.touched && searchForm.controls.batch.invalid && searchForm.dirty">
                                                {{ "THIS_FIELD_IS_REQUIRED" | translate | titlecase }}
                                            </div>
                                        </div>
                                        <div class="col-md-3 form-group px-md-5 mb-1">
                                            <label class="font-bold">{{ "FILTER_BY" | translate | titlecase }}</label>
                                            <select class="form-control custom-select" formControlName="filterType">
                                                <option value="" [selected]="true">{{ "SELECT" | translate |
                                                    titlecase
                                                    }}</option>
                                                <option *ngFor="let field of letterTypes" [value]="field.id">
                                                    {{
                                                    (globals.lang == 'ar')? field?.wtypeNameAr : field?.wtypeNameEn
                                                    }}
                                                </option>
                                            </select>
                                            <div class="alert alert-danger py-1 mt-1"
                                                *ngIf="searchForm.controls.filterType.touched && searchForm.controls.filterType.invalid && searchForm.dirty">
                                                {{ "THIS_FIELD_IS_REQUIRED" | translate | titlecase }}
                                            </div>
                                        </div>
                                        <!-- <div class="col-md-3 form-group px-md-5 mb-1">
                                            <label class="font-bold"> {{ "GROUP" | translate | titlecase }}</label>
                                            <select class="form-control custom-select" formControlName="group"
                                                (change)="getStudentsByGroup()">
                                                <option value="" [selected]="true">{{ "SELECT" | translate |
                                                    titlecase
                                                    }}</option>
                                                <option *ngFor="let field of groups" [value]="field.id">
                                                    {{(globals.lang == 'ar')? field.egroupNameAr :
                                                    field.egroupNameEn}} - ({{field.egroupCode}})</option>
                                            </select>
                                            <div class="alert alert-danger py-1 mt-1"
                                                *ngIf="searchForm.controls.group.touched && searchForm.controls.group.invalid && searchForm.dirty">
                                                {{ "THIS_FIELD_IS_REQUIRED" | translate | titlecase }}
                                            </div>
                                        </div> -->
                                        <div class="col-md-3 form-group px-md-5 mb-1">
                                            <label class="font-bold"> {{ "STUDENT" | translate | titlecase }}</label>
                                            <select class="form-control custom-select" formControlName="student">
                                                <option value="" [selected]="true">{{ "SELECT" | translate |
                                                    titlecase
                                                    }}</option>
                                                <option *ngFor="let field of allstudents" [value]="field.id">
                                                    {{field.id.toString() + " - " + ((globals.lang == 'ar')?
                                                    field.fullNameAr :
                                                    field.fullNameEn)}}</option>
                                            </select>
                                            <div class="alert alert-danger py-1 mt-1"
                                                *ngIf="searchForm.controls.student.touched && searchForm.controls.student.invalid && searchForm.dirty">
                                                {{ "THIS_FIELD_IS_REQUIRED" | translate | titlecase }}
                                            </div>
                                        </div>
                                    </div>

                                    <div class="row">
                                        <div class="col-md-3 form-group px-md-5 mb-1"
                                            style="padding-top: 23px !important;">
                                            <button type="submit" class="btn btn-primary">
                                                {{ "SEARCH" | translate | titlecase }}</button>
                                        </div>
                                    </div>

                                </form>
                            </div>
                        </div>
                    </div>
                </div>
                <br>

                <div class="row" *ngIf="searched">
                    <div class="col-md-2 form-group px-md-5 mb-1">
                        <!-- <div class="col-12 d-flex flex-wrap justify-content-between" *ngIf="globals.checkUserHasPermission('COUNTRIES - CREATE')"> -->
                        <button type="button" class="btn btn-success mb-2 mx-lg-0 mx-auto rounded-0"
                            routerLink="/scores-grades/warning-letters/warning-letter-create"
                            [queryParams]="{yearId: currentYear, semesterId: currentSemester, batchId: currentBatch, studentId: currentStudent,typeId:filterType}"><i
                                class="fas fa-plus"></i> {{ "ADD" |
                            translate |
                            titlecase }}</button>
                    </div>
                    <!-- <div class="col-md-2 form-group px-md-5 mb-1">
                        <button type="button" class="btn btn-success mb-2 mx-lg-0 mx-auto rounded-0"
                            (click)="print()"><i class="fas fa-print"></i> {{ "PRINT" |
                            translate |
                            titlecase }}</button>
                    </div> -->
                </div>
                <br />
                <div class="table-responsive py-3" *ngIf="!showLoader">
                    <table *ngIf="warningLetters.length >= 1 " class="table-striped" id="datatable">
                        <thead>
                            <tr>
                                <th>{{ "ID" | translate | titlecase }}</th>
                                <th>{{ "TYPE" | translate | titlecase }}</th>
                                <!-- <th>{{ "MAT_NO" | translate | titlecase }}</th> -->
                                <th>{{ "STUDENT_NAME" | translate | titlecase }}</th>
                                <th>{{ "COURSE" | translate | titlecase }}</th>
                                <th>{{ "TEACCHER" | translate | titlecase }}</th>
                                <th>{{ "NOTES" | translate | titlecase }}</th>
                                <th>{{ "STATUS" | translate | titlecase }}</th>

                                <th class="border-0 font-14 px-2 text-grey"></th>
                                <th class="border-0 font-14 px-2 text-grey"></th>
                                <th class="border-0 font-14 px-2 text-grey"></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let res of warningLetters let i = index">
                                <td>{{res?.id}}</td>
                                <td>
                                    {{
                                    (globals.lang == 'ar')? res?.letterType.wtypeNameAr : res?.letterType.wtypeNameEn
                                    }}
                                </td>
                                <!-- <td>{{res?.matNo}}</td> -->
                                <td>
                                    {{
                                    (globals.lang == 'ar')? res?.student.fullNameAr : res?.student.fullNameEn
                                    }}
                                </td>
                                <td>
                                    {{
                                    (globals.lang == 'ar')? res?.course.subjectNameAr : res?.course.subjectNameEn
                                    }}
                                </td>
                                <td>
                                    {{
                                    (globals.lang == 'ar')? res?.teacher.teacherNameAr : res?.teacher.teacherNameEn
                                    }}
                                </td>
                                <td>{{res?.remarks}}</td>
                                <td>{{res?.warnStatus}}</td>

                                <td class="text-bold">
                                    <button type="button" class="btn btn-primary"
                                        (click)="approveWarningLetter(res?.id)" *ngIf="res?.warnStatus != 'FINAL'">
                                        {{ "APPROVE" | translate | titlecase }}</button>
                                </td>
                                <!-- *ngIf="res?.status == 'DRAFT'" -->
                                <td class="text-bold text-warning">
                                    <a class="btn btn-sm btn-link text-warning"
                                        routerLink="/scores-grades/warning-letters/warning-letter-update"
                                        [queryParams]="{yearId: currentYear, semesterId: currentSemester, batchId: currentBatch, groupId: currentGroup, studentId: currentStudent,letterId: res?.id,typeId:filterType}"
                                        *ngIf="res?.warnStatus != 'FINAL'"><i class="fas fa-edit"></i>
                                        {{ "MODIFY" | translate | titlecase }}</a>
                                </td>
                                <td class="text-bold">
                                    <button type="button" class="btn btn-info mb-2 mx-lg-0 mx-auto rounded-0"
                                    (click)="print(res?.id)"data-toggle="modal" data-target="#printModal"><i class="fas fa-print"></i> {{ "PRINT" |
                                        translate |
                                        titlecase }}</button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="modal fade" id="printModal" tabindex="-1" aria-labelledby="printModalLabel" aria-hidden="true">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-body font-16 d-flex justify-content-between">
                <div class="p-2">
                    <!-- <i class="fas fa-trash text-danger"></i> -->
                    <a type="button" class="btn btn-link text-grey" (click)="printValu()">
                        <i class="fas fa-arrow-down"></i>
                        </a>
                    <button printSectionId="section" ngxPrint>Print</button>
                </div>
                <!-- <div class="p-2"><b>{{ "ARE_YOU_SURE" | translate | titlecase }}</b> </div> -->
                <div id="section" [innerHTML]="letterHtml"></div>
                <!-- <button printSectioId="section" ngxPrint>Print</button> -->
                <!-- <a type="button" class="btn btn-link text-danger"
                    data-dismiss="modal">{{ "YES"
                    | translate | titlecase }}</a> -->
                <a type="button" class="btn btn-link text-grey" data-dismiss="modal"><i
                        class="fas fa-times-circle"></i></a>
            </div>
        </div>
    </div>
</div>
